<div class="access-toolbar" role="group" aria-label="Opciones de accesibilidad">
  <button type="button" class="btn" (click)="toggleContrast()" [attr.aria-pressed]="highContrast">◐</button>
  <button type="button" class="btn" (click)="decreaseFont()">A-</button>
  <button type="button" class="btn" (click)="increaseFont()">A+</button>
</div>
